import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import {
  toastSuccess,
  toastError,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/toast';
import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import service from '@Service';
import type { OperationActionTriggerProps } from '@Constants/operations';

/**
 * Runs the lapse-detection brain now. The endpoint is synchronous and records a
 * JobRuns row before responding, so we just invalidate the feed to reveal the run.
 */
export default function RunLapseDetectionTrigger({
  onSuccess,
}: OperationActionTriggerProps) {
  const [running, setRunning] = useState(false);
  const queryClient = useQueryClient();

  const handleRun = async () => {
    setRunning(true);
    try {
      const res = await service.runLapseDetection();
      const emitted = res?.data?.lapsedEmitted ?? 0;
      toastSuccess(`Lapse sweep complete — ${emitted} lapse event(s).`);
      queryClient.invalidateQueries({ queryKey: ['job-runs-by-type', 'detect-lapses'] });
      onSuccess();
    } catch {
      toastError('Failed to run lapse detection.');
    } finally {
      setRunning(false);
    }
  };

  return (
    <Button variant="outline" size="sm" onClick={handleRun} loading={running} disabled={running}>
      {running ? 'Running…' : 'Run Lapse Sweep'}
    </Button>
  );
}
